/**
 * The line icons the artboards draw. Stroke 1.8, round caps, sized by the
 * caller — they inherit `currentColor` so a nav item's active state moves the
 * icon with the label.
 */
const Svg = ({ size = 16, children, className = '' }: {
  size?: number,
  children: React.ReactNode,
  className?: string,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`flex-none ${className}`}
    aria-hidden="true"
  >
    {children}
  </svg>
)

type IconProps = { size?: number, className?: string };

const path = (d: string) => ({ size, className }: IconProps) => (
  <Svg size={size} className={className}><path d={d} /></Svg>
);

export const OverviewIcon = path('M3 3h8v8H3zM13 3h8v5h-8zM13 10h8v11h-8zM3 13h8v8H3z');
export const DeploymentsIcon = path('M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z');
export const LogsIcon = path('M4 6h16M4 12h10M4 18h13');
export const MetricsIcon = path('M3 17l6-6 4 4 8-8');
// Stepped rules, so it does not read as a second Logs icon two groups down.
export const VariablesIcon = path('M4 7h16M4 12h11M4 17h7');
export const SettingsIcon = path('M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM4.9 5.1l1.6 1.6M17.5 17.5l1.6 1.6M19.1 5.1l-1.6 1.6M6.5 17.5l-1.6 1.6M12 2v3M12 19v3M2 12h3M19 12h3');

export const FileIcon = path('M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6');
export const PortIcon = path('M3 5v14M21 5v14M3 5a9 3 0 0 0 18 0A9 3 0 0 0 3 5zM3 12a9 3 0 0 0 18 0M3 19a9 3 0 0 0 18 0');
export const GlobeIcon = path('M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM2 12h20M12 2a15 15 0 0 1 0 20a15 15 0 0 1 0-20');
export const BranchIcon = path('M6 3v12M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 9a9 9 0 0 1-9 9');

export const PlusIcon = path('M12 5v14M5 12h14');
export const CheckIcon = ({ size, className }: IconProps) => (
  <svg width={size ?? 16} height={size ?? 16} viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" className={`flex-none ${className ?? ''}`} aria-hidden="true">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);
export const ChevronRightIcon = path('M9 18l6-6-6-6');
export const ChevronDownIcon = path('M6 9l6 6 6-6');
export const ExpandIcon = path('M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7');

export const ArrowLeftIcon = ({ size, className }: IconProps) => (
  <Svg size={size} className={className}>
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </Svg>
);

export const ExternalLinkIcon = ({ size, className }: IconProps) => (
  <Svg size={size} className={className}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <path d="M15 3h6v6M10 14L21 3" />
  </Svg>
);

export const SearchIcon = ({ size, className }: IconProps) => (
  <Svg size={size} className={className}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </Svg>
);

export const AlertIcon = ({ size, className }: IconProps) => (
  <Svg size={size} className={className}>
    <path d="M12 8v5M12 16.5v.5" />
    <circle cx="12" cy="12" r="9.5" />
  </Svg>
);
